<template>
    <div>
        <slot name="infoBar"></slot>
        <div class="m-checkList d-flex gap-1 flex-wrap">
            <div
                class="custom-checkbox"
                style="white-space: nowrap"
                v-if="selectAll"
            >
                <the-btn
                    text="Zaznacz wszystkie"
                    class="btn-outline-custom d-none d-sm-inline-flex"
                    :class="{ 'd-inline-flex': !allowSelectAll }"
                    icon="CheckCorrect"
                    @click.native="selectAll(true)"
                />
                <the-btn
                    text="Odznacz wszystkie"
                    class="
                            btn-danger
                            ml-sm-2
                            d-none d-sm-inline-flex
                        "
                    :class="{ 'd-inline-flex': allowSelectAll }"
                    icon="CheckIncorrect"
                    @click.native="selectAll(false)"
                />
            </div>
            <slot></slot>
        </div>
        <div class="m-checkList__rows scrollbar">
            <check-list-row
                v-for="row in list"
                :key="row.id"
                :row="row"
                :selectRow="selectRow"
                :selectedRows="selectedRows"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            required: true
        },
        selectAll: {
            type: Function
        },
        selectRow: {
            type: Function,
            default: () => {}
        },
        selectedRows: {
            type: Array,
            default: () => []
        },
        rowInfo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        allowSelectAll() {
            return this.list.length === this.selectedRows.length
        }
    }
}
</script>
